export const EXPERIENCES = [
  {
    period: 'Jul 2026 – Present',
    company: 'ORCAWISE',
    companyNote: 'Enterprise AI & responsible AI platform',
    role: 'Artificial Intelligence Engineer',
    location: 'Dublin, Ireland',
    type: 'Full-time',
    summary:
      'Fine-tune Llama models with SFT, LoRA, and RLHF on AWS SageMaker, and run an agentic RAG platform over 10,000+ enterprise documents. Cut document processing time by 60% (8–10 minutes to 3–4 minutes) and reduced manual processing effort by 30%.',
    tech: ['Python', 'Llama', 'LoRA', 'RLHF', 'SageMaker', 'RAG', 'AWS', 'W&B'],
    points: [
      'Fine-tuned Llama-based foundation models using SFT, LoRA, and RLHF (PPO/GRPO) on AWS SageMaker, improving model alignment, response quality, and reducing hallucinations across enterprise AI workflows.',
      'Architected and deployed an agentic AI platform integrating Generative AI, RAG, tool calling, and semantic retrieval over 10,000+ enterprise documents, reducing manual document processing effort by 30%.',
      'Built scalable LLM training, evaluation, and inference pipelines on AWS (SageMaker, EC2, S3, Lambda), enabling reproducible experimentation and efficient model deployment using Weights & Biases.',
      'Led AI solution development and deployment on approved enterprise AI platforms, driving model evaluation, model monitoring, and continuous improvement to ensure solution quality and reliability.',
      'Reduced enterprise document processing time by over 60% (8–10 minutes to 3–4 minutes per document) by combining fine-tuned LLMs, semantic retrieval, and workflow automation.',
    ],
  },
  {
    period: 'Jun 2020 – Aug 2024',
    company: 'Panghat',
    companyNote: 'Legal-tech startup building AI search over case law',
    role: 'Machine Learning Engineer',
    location: 'Mumbai, India',
    type: 'Full-time',
    summary:
      'Built semantic search over 500,000+ legal cases, lifting top-5 retrieval 35% vs BM25, and a RAG assistant at 92% answer relevance. Shipped FastAPI inference on Kubernetes at 1,000+ daily requests, with 10× faster vector search through HNSW and Milvus.',
    tech: ['Python', 'DPR', 'BGE', 'Milvus', 'FastAPI', 'Docker', 'Kubernetes', 'LangChain'],
    points: [
      'Improved top-5 retrieval relevance by 35% across 500,000+ legal case documents by developing semantic search pipelines using DPR-CTX, BGE embeddings, and vector search, outperforming the BM25 baseline.',
      'Built and deployed containerized ML inference services using Python, Docker, Kubernetes, and FastAPI, serving 1,000+ daily requests with sub-100ms latency and enabling application integration across systems.',
      'Owned DevOps and CI/CD for the inference stack, delivering infrastructure automation and cloud-native service implementation that cut release cycles and strengthened operational support for production workloads.',
      'Optimized vector search performance by 10× through HNSW index tuning and Milvus optimization, significantly improving large-scale semantic retrieval efficiency.',
      'Developed a Retrieval-Augmented Generation assistant using LangChain, GPT-4, and semantic search, achieving 92% answer relevance in internal evaluations.',
    ],
  },
  {
    period: 'Feb 2025 – May 2026',
    company: 'Technological University of Dublin',
    companyNote: 'Machine Learning & Python labs',
    role: 'Teaching Assistant',
    location: 'Dublin, Ireland',
    type: 'Part-time',
    summary:
      'Delivered Machine Learning and Python labs to 50+ undergraduate students at TU Dublin, with reusable ML workflow documentation covering security, compliance, and governance.',
    tech: ['Python', 'Machine Learning', 'Teaching'],
    points: [
      'Delivered Machine Learning and Python labs to 50+ undergraduate students, mentoring in machine learning fundamentals, model implementation, and software engineering best practices.',
      'Published technical documentation and reusable artifacts for ML workflows, reinforcing security, compliance, and governance standards as part of enterprise engineering practice.',
    ],
  },
];

export const EDUCATION = [
  {
    degree: 'MSc, Human Centered Artificial Intelligence',
    school: 'Technological University of Dublin',
    period: 'Sep 2024 – Oct 2025',
    focus: 'Explainable AI · AI governance for regulated environments',
  },
  {
    degree: 'MSc, Information Technology',
    school: 'University of Mumbai',
    period: 'Aug 2020 – May 2022',
    focus: 'Machine Learning · Data Science',
  },
  {
    degree: 'BSc, Information Technology',
    school: 'University of Mumbai',
    period: 'Aug 2017 – May 2020',
    focus: 'Software Engineering · DBMS',
  },
];
